import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangCnIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
		fill: "#D80027"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m4.925 5.477.777 2.39h2.514l-2.032 1.48.777 2.39-2.036-1.476-2.035 1.477.78-2.39-2.035-1.48h2.513l.777-2.391Zm5.745 8.463-.593-.732-.88.34.51-.79-.594-.735.91.243.514-.791.05.942.913.242-.882.338.053.942Zm1.182-2.146.281-.9-.77-.544.943-.014.277-.9.306.893.942-.011-.756.563.303.892-.77-.544-.756.566Zm1.591-5.188-.415.847.675.657-.931-.133-.415.844-.162-.929-.935-.133.837-.44-.162-.931.675.657.833-.44ZM10.694 4.04l-.07.938.875.355-.917.225-.067.942-.496-.802-.917.225.608-.72-.5-.798.876.355.608-.72Z",
		fill: "#FFDA44"
	})]
});
const ForwardRef = forwardRef(SvgLangCnIconmin);
export { ForwardRef as ReactComponent };
